import { createBrowserClient } from '@supabase/ssr'
import { getSupabaseAnonKey, getSupabaseUrl } from './env'

export function createClient() {
  const supabaseUrl = getSupabaseUrl()
  const supabaseKey = getSupabaseAnonKey()

  if (!supabaseUrl || !supabaseKey) {
    throw new Error(
      'Missing Supabase URL/key. Set NEXT_PUBLIC_SUPABASE_URL + NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY (or legacy SUPABASE_URL + SUPABASE_ANON_KEY).'
    )
  }

  return createBrowserClient(supabaseUrl, supabaseKey)
}
